"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.load = load;
exports.dragOver = dragOver;
exports.drop = drop;
exports.loadSampleFromFile = loadSampleFromFile;

var _tone = require("tone");

var _tone2 = _interopRequireDefault(_tone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /**
                                                                                                                                                                                                     * Sampler
                                                                                                                                                                                                     * @module lib/sampler.js;
                                                                                                                                                                                                     */

var root = 440;

var output = void 0;
var ready = void 0;
var current = "";
var samples = {};

var player_count = 12;

function load(out, readyCallback) {
  output = out;
  ready = readyCallback;
  document.body.addEventListener("dragover", dragOver);
  document.body.addEventListener("drop", drop);
}

/**
 * Drag and drop
 */
function dragOver(event) {
  event.preventDefault();
}
function drop(event) {
  event.preventDefault();
  var files = event.dataTransfer.items ? [].concat(_toConsumableArray(event.dataTransfer.items)).filter(function (item) {
    return item.kind === "file";
  }).map(function (item) {
    return item.getAsFile();
  }) : [].concat(_toConsumableArray(event.dataTransfer.files));

  var file = files[0];
  var reader = new FileReader();

  reader.addEventListener("load", function () {
    return loadSampleFromFile(file, reader.result);
  }, false);

  if (file) {
    reader.readAsDataURL(file);
  }
}

function loadSampleFromFile(file, url) {
  var name = file.name;

  current = name;

  var sample = samples[name] = samples[name] || {};
  sample.root = 440;
  sample.players = [];
  sample.index = -1;
  for (var i = 0; i < player_count; i++) {
    var player = new _tone2.default.Player({
      url: url,
      retrigger: true,
      playbackRate: 1
    });
    player.name = name;
    player.connect(output);
    sample.players.push(player);
  }
  console.log("+ Sampler:", name, "(" + sample.players.length + " voices)");
  ready();
}

/**
 * Player
 */
var last = [1, 440];

function stop() {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = Object.values(samples)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var sample = _step.value;

      sample.players.forEach(function (player) {
        return player.stop();
      });
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}
function play(interval, root) {
  last = [interval, root];
  var sample = samples[current];
  sample.index = (sample.index + 1) % sample.players.length;
  var player = sample.players[sample.index];
  player.playbackRate = interval * root / sample.root;
  player.start();
}

function pause() {
  // no-op
}

exports.default = { load: load, play: play, pause: pause, stop: stop };

// for help tuning

function keydown(e) {
  if (document.activeElement !== document.body) {
    return;
  }
  // console.log(e.keyCode)
  if (e.metaKey && last && current) {
    var sample = samples[current];
    var step = e.shiftKey ? e.ctrlKey ? 0.1 : 1 : 10;
    switch (e.keyCode) {
      case 38:
        // up
        e.preventDefault();
        sample.root -= step;
        stop();
        play(last[0], last[1]);
        break;
      case 40:
        // down
        e.preventDefault();
        sample.root += step;
        stop();
        play(last[0], last[1]);
        break;
    }
  }
}
window.addEventListener("keydown", keydown, true);


//////////////////
// WEBPACK FOOTER
// ./client/lib/sampler.js
// module id = 266
// module chunks = 0